module.exports = __webpack_public_path__ + "static/media/caravanlogo.6c5f8078.svg";